import { useState, useEffect } from 'react';

export const useStateCallbackWrapper = (initialValue: any, callBack: any) => {
  const [state, setState] = useState(initialValue);
  useEffect(() => callBack(state), [state]);
  return [state, setState];
};
